const products = {
  "Bralette - Dusted Black, Sizes 32-44": 10500,
  "Brazilian Push-Up Bra - A-C, Sizes 32-44": 8000,
  "Classic Underwire Bra - Dark Forest, Sizes 32-44": 8500,
  "Comfortable Wirefree First Bra - White, Sizes 32-44": 7500,
  "Electrify Underwire Bra - Wild Side, Sizes 32-44": 10000,
  "Endless Comfort Wirefree Bra – Fig Pink, Sizes 32-44": 10500,
  "Essential Lace Underwire Bra – Sunrose Pink, Sizes 32-44": 8000,
  "Full Coverage Bra – Black, Sizes 32-44": 11000,
  "Graduated Push Up Bra – Latte, Sizes 32-44": 7000,
  "Hipster Contour Bra – Black, Sizes 32-44": 9500,
  "Lace Softcup Mould Bra – A-C, Sizes 32-44": 7000,
  "Lace Trim Push-Up Strapless Bra – Ivory, Sizes 32-44": 10000,
  "Lightly Lined Retro Bralette – Plein Air, Sizes 32-44": 7500,
  "Midnight Express Underwire Bra – Winsome Orchid, Sizes": 7000,
  "Modal Bralette – Seaside Daisy, Sizes 32-44": 8500.0,
  "Multiway Strapless Bra – Black, Sizes 32-44": 11000,
  "Perfect Lines Contour Bra – White, Sizes 32-44": 10500,
  "Post-Surgery Lace Contour Bra – Black/Nude": 7500,
  "Push Up Bra – Pool Blue, A-D": 11000,
  "Ribbed Triangle Crop Top Bra – Black, Sizes 32-44": 9500,
  "Sheer Minimiser Bra – Black, Sizes 32-44": 9500,
  "Sienna Wirefree Lace Bra – Black, Sizes 32-44": 7000,
  "Stylish Strapless Comfort: Alive Bandeau Bra": 7000,
  "Triaction Ultra Underwire Bra – Iris, Sizes 32-44": 9000,
  "Underwire Bra – Tawny Port, Sizes 32-44": 11000,
  "Wirefree Bra – Hyper Candy, Sizes 32-44": 8500,
  "Wirefree First Bra – Black, Sizes 32-44": 9500,
  "Wirefree Post-Surgery Contour Bra – Lace Black": 10500,
  "Zero Feel Bralette – Perola, Sizes 32-44": 9000,
  "Charming Elegance: Super Soft Lace Trim Cheeky Panty": 9000,
  "Cotton and Lace Band Thong Panty": 4000,
  "Cotton and Lace Trim Cheeky Panty – Red & Blue Plaid": 4500,
  "Cotton Bikini Panty Blue": 5000,
  "Cotton Essentials Cheeky Panty": 3500,
  "Cotton High Waist Bikini Panty": 4000,
  "Cotton Lace-Trim Mid-Rise Thong Panty": 5000,
  "Cotton String Bikini Panty": 5500,
  "Elegant Comfort: Microfiber and Lace Cheeky Panty": 6200,
  "Elegant Comfort: Microfiber Bonded High-Waist Bikini": 6000,
  "Flirty Elegance: Lace Trim Microfiber Cheeky Panty": 6500,
  "Heart-shaped Microfiber and Lace Panty": 3000,
  "Lace and Bow Panty Comfort and Style": 5100,
  "Lace Cheeky Panty": 4500,
  "Lace Trim Ribbed Bikini Panty": 4500,
  "Light Absorbency Lace Detail Thong Period Panty": 5000,
  "Mesh and Lace Trim Cheeky Panty with Bow": 5000,
  "Microfiber and Lace Trim Cheeky Panty": 6000,
  "Microfiber and Mesh Sleek Back Bikini Panty": 5500,
  "Microfiber Bonded Bikini Panty": 5500,
  "Microfiber Bonded High Waist Bikini Panty": 6000,
  "Microfiber Sleek Back Bikini Panty – White": 5500,
  "Panty with Bow Classic Black": 5500,
  "Reliable Comfort: Super Absorbency Hiphugger Period": 6000,
  "Roses Lace Thong Panty": 5000,
  "Seamless Comfort: Microfiber Bonded Bikini Panty": 5000,
  "Seamless Fabric Bikini Panty": 5000,
  "Sky Lace Panty": 4000,
  "Sleek Minimalism: Microfiber Bonded Thong Panty": 6500,
  "Super Absorbency Hiphugger Period Panty": 5000,
  "Adele Embroidered Bodysuit in Black/Nude": 15000,
  "Brazilian Chemise in Pool Blue": 19000,
  "Chloe Jacquard Bodysuit in Black": 14500,
  "Demilicious Linear Lace Demi Padded Set": 20000,
  "Elegant Corded Lace Underwire Bodysuit": 16000,
  "Floral Embroidered Mesh and Lace-Up Push-Up Nightie": 16500,
  "Floral Embroidered Mesh and Lace-Up Push-Up Teddy": 15000,
  "Floral Embroidered Mesh Push-Up Nightie – Blushing": 17000,
  "Floral Embroidered Mesh Push-Up Teddy – Black": 17000,
  "Floral Lace and Mesh 2-Piece Set – Blushing Pink": 18000,
  "Floral Lace and Mesh Romper – Black": 18000,
  "Floral Lace and Mesh Romper – Blushing Pink": 15000,
  "High-Neck Lace Thong Teddy – Blushing Pink": 17000,
  "Lace Insert Microfiber Cami – Blushing Pink": 16000,
  "Long-Sleeve Lace 2-Piece Set – Classic Black": 17000,
  "Long-Sleeve Lace and Microfiber Teddy – Classic": 17000,
  "Open-Back Microfiber and Lace Nightie – Candy Cane": 15000,
  "Parisienne Classic Cami in Winter Bouquet": 17500,
  "Sunchaser Lace Underwire Teddy": 17000,
  "Cable Knit Chenille Crop T-Shirt – Evening Haze": 15000,
  "Fair Isle Print Cable Knit Hooded Robe – Grey Fair Isle": 12000,
  "Fair Isle Print Sherpa Robe – Pink Fair Isle Print": 12000,
  "Fire and Desire Satin Sleep 2-Piece Set": 18000,
  "Les Roses Lace Bralette 3-Piece Set": 17500,
  "Lightly Ribbed Crew Neck Sweatshirt and Jogger Pants": 19500,
  "Long Faux Fur and Plush Robe – Classic Black": 11000,
  "Olive Ribbed Crew Neck Lounge Set": 19500,
  "Rabbit Print Soft Plush Hooded Robe – Rabbit Snow": 12000,
  "Recycled Fibers Cable Knit Robe – Navy Blue": 13000,
  "Undercover Softie Plush 2 Piece Set": 14000,
  "Velvety Softness Long Robe – Icy Blue Garden": 12000,
  "Soft Plush Hooded Robe – Mint Green": 13500,
  "6-Piece Satin Heart Print Pajama Set Sizes S to XXL": 11000,
  "Satin Boxy Shirt and Boxer Short Pajama Set Sizes S": 10500,
  "Satin Contrast Piping Tie Sleeve Pajama Pants Set": 13500,
  "Satin Oversized Shirt, Bralette, and Trouser 3-Piece": 10000,
  "Tile Print Satin Long Pajama Set Sizes S to XXL": 15500,
  "Vintage Floral Ruffle Short Pajama Set Sizes S to XXL": 15500,
  "Body Define Ultimate Slip Warm Taupe Sizes S to XXL": 10000,
  "Body Smart Waisted Short Beige Sizes S to XXL": 10000,
  "Full-Body Shapewear Bodysuit – Black": 9000,
  "High Waisted Shaping Shorts Black Sizes S to XXL": 10000,
  "High-Waist Minimizer Shapewear Briefs Beige": 5000,
  "High-Waist Shaping Shorts – Black": 5500,
  "Lace High Waist Thong Black Sizes S to XXL": 7500,
  "Lace High Waist Thong Taupe Sizes S to XXL": 6500,
  "Seamless Thigh Shaping Shorts Rose Beige": 6500,
  "Revive Smooth Waisted Brief Black Sizes S to XXL": 6500,
  "Revive Smooth Waisted Brief Warm Taupe Sizes S to XXL": 8500,
  "Seamless Thigh Shaping Shorts – Black": 6000,
  "X-Factor High Waist Thong Brief Warm Taupe Sizes S to": 12500,
  "Boho Vibes: Pom Pom Crochet Underwire Bikini and Sarong Set": 8500,
  "Bold & Elegant: Santa Monica Strapless Tummy Control": 10500,
  "Bold & Flattering: Palm Springs Colour Block Tummy": 11500,
  "Bold & Stylish: Sun Trim Cut Out Swimsuit": 10500,
  "Bold and Beautiful: Strapless Underwired Bikini Top": 9500,
  "Border Tile Print Belted Plunge Swimsuit": 9000,
  "Chic & Bold: Textured Ring Cut Out Swimsuit": 10500,
  "Effortless Chic: Crinkle One Shoulder Swimsuit": 10000,
  "Floral Serenity: Ocean Breeze Underwired Bikini Top": 9000,
  "Minimalist Glam: High Leg Crinkle Bandeau Swimsuit": 10000,
  "Sleek & Stylish: One Shoulder Ring Detail Swimsuit": 8500,
  "Vibrant Elegance: Lightly Padded Twist Front Bikini Top": 9000,
  "Versatile Elegance: Convertible Underwired Bikini": 9000,
  "Baggy Jeans – Low-Rise Wide-Leg Blue Denim Jean": 7000,
  "Back Strap Square Neck Dress": 11000,
  "Baggy low rise jean House fit": 9000,
  "Fitted Off-the-Shoulder T-Shirt – Twik": 5500,
  "High-Rise Mom Jeans – Old School Fit": 9500,
  "Long-Sleeve Plain Jersey Polo – Contemporaine": 4000,
  "Hope Is Pink T-Shirt": 6000,
  "Low-Rise Bootcut Women’s Denim Jeans": 8000,
  "Scoop Neck Tee For Women": 5500,
  "Short Checkered Dresses": 8000,
  "Short Dresses Puff Sleeve": 8000,
  "Square neck Mini Dress": 8000,
  "Sweetheart neckline dress": 8500,
  "Thin Jersey Cardigan": 5000,
  "Thin Stripe T Shirt": 6000,
  "Tie-collar chain pattern dress": 7500,
  "Wayfaring dress": 15500,
  "Wool and Organic Cotton Fitted T-Shirt": 6500,
  "Zip collar knit dress": 10500,
  "6 Mini Lip Serum Collection": 1000,
  "A Little Lip2Cheek Kit": 5000,
  "Angled Blush Brush": 6000,
  "Blush & Glow Mini Bar": 4500,
  "Cream Blush Stick": 5500,
  "Creature Of Light Full-Face Serum Illuminator": 6000,
  Highlighter: 6000,
  "Hydra Lip Balm Duo": 6000,
  "Iconic Edition Compact Cream Foundation": 4500,
  "KANARI Precision Colour Pencil – Limited Edition": 3500,
  "Let It Glow Advent Calendar": 20000,
  "Lightshift Cream Highlighter": 5500,
  "Petite Manucurist Holidays Trio Set": 3500,
  "Red Edition Compact Powder Bronzer": 1000,
  "Red Edition Compact Pressed Powder": 2000,
  "Redimension Hydra Bronzer Refill": 3500,
  "Repurpose Capsule": 1000,
  "Sculpting Brush": 6000,
  "Skin2Skin Classic Fan Brush": 3500,
  "Tete-A-Tete": 4000,
  "The Party Set": 8000,
  "8 Hair Ties in a Tin, Assorted": 1500,
  "Aviator Sunglasses, Gold Tone": 3500,
  "Be My Valentine Locket Necklace Gift, Gold Tone": 2000,
  "Beaded Bracelet Stack, Gold Tone": 1500,
  "Black Sunglass Cat Eye Style": 2600,
  "Butterfly Print Scarf": 3500,
  "Chunky Heart Earrings, Gold Tone": 1400,
  "Classic Scarf, Carnation Pink": 3000,
  "Classic Scarf, Navy": 3000,
  "Denim Cap, Light Blue": 800,
  "Fascinator, Navy": 1800,
  "Gingham Cap, Light Beige": 1000,
  "Harlow Esme Fascinator, Pink": 2000,
  "Resort Crochet Straw Bucket Hat, Black": 600,
  "Resort Towelling Bucket Hat, Green": 500,
  "Roll-Up Packable Sunhat, Natural": 900,
  "Round Tort Buckle Elasticated Belt, Natural": 4000,
  "Shell Hoop Earrings, Gold Tone": 2500,
  "Sparkle Pearl Headband Set, 3 Pack, Gold Tone": 1000,
  "Sun Hat, Navy": 700,
  "Toffee Floral Sunglasses": 2500,
};

const orgDetails = {
  orgName: "Jinkies Tech Private Limited",
  phoneNumber: "+91 8929829949",
  orgAddress:
    "10th Floor, Unit No. 1012, Plot No. C9, Pearls Best Heights-2, Pitampura, North West Delhi, New Delhi 110034",
  gstNumber: "O7AAFCJ8I45D1ZM",
};

const shortName = "OB";

const jinkies = { products, orgDetails, shortName };
export default jinkies;
